<section class="search-dialog">
  <div class="search-input-row">
    <input
      (input)="onInput($event)"
      [(ngModel)]="searchName"
      class="search-input"
      type="search"
      placeholder="Find Product…"
      autocomplete="off"
    />
    <button class="search-btn" [disabled]="!searchName.trim()" (click)="viewAll()">
      Search
    </button>
  </div>

  <!-- Loading -->
  <div class="search-loading" *ngIf="isLoading">
    <span class="search-spinner"></span>
  </div>

  <!-- Results -->
  <ul class="search-results" *ngIf="!isLoading && results.length > 0">
    <li
      class="search-result-item"
      *ngFor="let item of results | slice:0:8"
      (click)="selectProduct(item)"
    >
      <div class="sri-img">
        <img
          [src]="item.images?.[0]?.image_url || 'assets/images/rk.jpeg'"
          [alt]="item.name"
        />
      </div>
      <div class="sri-info">
        <span class="sri-name">{{ item.name }}</span>
        <div class="sri-price-row">
          <span class="sri-was" *ngIf="item.discount > 0">LE {{ item.price }}</span>
          <span class="sri-price">LE {{ effectivePrice(item) }}</span>
          <span class="sri-badge" *ngIf="item.discount > 0">{{ item.discount }}% OFF</span>
        </div>
      </div>
      <i class="ti-arrow-right sri-arrow"></i>
    </li>

    <li class="search-view-all" *ngIf="results.length > 0" (click)="viewAll()">
      See all results for "<strong>{{ searchName }}</strong>"
      <i class="ti-arrow-right"></i>
    </li>
  </ul>

  <!-- No results -->
  <div class="search-empty" *ngIf="!isLoading && hasSearched && results.length === 0">
    No products found for "<strong>{{ searchName }}</strong>"
  </div>
</section>
